import styles from './ViewportToggler.css';

import {distinctUntilChanged, map} from 'rxjs/operators';

import {streamScreenDimensions} from '../../Applications/Utils/streamScreenDimensions';

export default ($node: Element) => {
	if ($node instanceof HTMLElement) {
		const breakpoint = parseInt($node.dataset.breakpoint ?? '970', 10);
		const $contentBeforeBreakpoint = $node.querySelector('[data-select="beforeBreakpoint"]');
		const $contentFromBreakpoint = $node.querySelector('[data-select="fromBreakpoint"]');

		if (!isNaN(breakpoint)) {
			streamScreenDimensions
				.pipe(
					map(({width}) => width < breakpoint),
					distinctUntilChanged()
				)
				.subscribe((isBeforeBreakpoint: boolean) => {
					if ($contentBeforeBreakpoint instanceof HTMLElement) {
						$contentBeforeBreakpoint.classList.toggle(styles.hidden, !isBeforeBreakpoint);
					}
					if ($contentFromBreakpoint instanceof HTMLElement) {
						$contentFromBreakpoint.classList.toggle(styles.hidden, isBeforeBreakpoint);
					}
				})
		}
	}
}
